/** Lower-cased with accents stripped, so "cote" finds "Côte d’Ivoire". For search filters only. */
export function fold(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}
